import React from "react";
import { Button } from "@mui/material";

export default (props) => <Button {...props} style={{ outline: "none", ...props.style }} />; /// Anti bootstrap shit
